"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringNormalizer = void 0;
class StringNormalizer {
    static normalize(string, ignoreOptions) {
        if (ignoreOptions !== undefined) {
            if (ignoreOptions.case) {
                string = string.toLowerCase();
            }
            if (ignoreOptions.diacritic) {
                string = string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            }
            if (ignoreOptions.space) {
                string = string.replace(/\s/g, "");
            }
            if (ignoreOptions.wave) {
                string = string.replace(/～/g, "");
            }
        }
        return string;
    }
}
exports.StringNormalizer = StringNormalizer;
